import { FontSizes, FontWeights } from '@calm-web/design-system';

import { useAnalytics } from '@/hooks/analytics/useAnalytics';

import { BodyText, Container, CtaButton, HeaderText } from './styles';

export interface CtaWithButtonProps {
	headerText: string;
	bodyText: string;
	buttonText: string;
	href: string;
	isLoudCta: boolean;
	context?: Record<string, string>;
	logPrefix?: string;
}

const CtaWithButton: React.FC<CtaWithButtonProps> = ({
	headerText,
	bodyText,
	buttonText,
	href,
	isLoudCta,
	context,
	logPrefix,
}) => {
	const { logEvent } = useAnalytics();

	return (
		<Container>
			<HeaderText
				el="h2"
				color="gray8"
				size={FontSizes.lg}
				align="center"
				weight={FontWeights.Medium}
				noMargin
			>
				{headerText}
			</HeaderText>
			<BodyText el="p" color="gray6" align="center" weight={FontWeights.Regular} noMargin>
				{bodyText}
			</BodyText>
			<CtaButton
				data-testid="cta-button"
				textColor={isLoudCta ? 'white' : 'blue3'}
				backgroundColor={isLoudCta ? 'gradientCalmBrand' : 'white'}
				borderColor={isLoudCta ? undefined : 'blue3'}
				fullWidth
				fontWeight={FontWeights.Demi}
				href={href}
				openInNewTab={true}
				onPress={() => {
					const ctaWithButton = 'CtaWithButton';
					const log = logPrefix ? `${logPrefix} : ${ctaWithButton}` : ctaWithButton;
					logEvent(log, { href, action: 'click', ...(context ?? {}) });
				}}
			>
				{buttonText}
			</CtaButton>
		</Container>
	);
};

export default CtaWithButton;
